app.directive('templateChooser', ['userModel', 'templateModel', '$mdDialog',
    function(userModel, templateModel, $mdDialog) {
        var definition = {
            restrict: 'E',
            replace: true,
            templateUrl: 'edm/application/directive/templateChooser/template/template-chooser.html',
            scope: {
                visitCard: '=',
                showTemplates: '=',
                selectTemplate: '&'
            },
            link: function($scope, element, attr, formCtrl) {
                function getDataPage() {
                    $scope.loadingInProgress = true;
                    templateModel.getDataPage($scope.criteria).then(function (dataPage) {
                        $scope.templates = dataPage.data;
                        $scope.loadingInProgress = false;
                    });
                }

                $scope.criteria = new TemplateDataGridCriteria();
                $scope.criteria.rowsPerSheet = 5;
                $scope.criteria.clinicId = userModel.currentUser.clinicId;
                $scope.criteria.sortColumns = [new EsDataGridSort('name')];

                $scope.templateCreateMode = false;

                $scope.templateName = null;

                if(!attr.showTemplates) {
                    $scope.showTemplates = true;
                }

                $scope.save = function () {
                    if($scope.templateName) {
                        var template = TemplateVO.fromVisitCard($scope.visitCard);
                        template.name = $scope.templateName;
                        templateModel.save(template).then(function (newTemplate) {
                        });
                    }
                };

                $scope.useTemplate = function (template) {
                    templateModel.getById(template.id).then(function (template) {
                        var f = $scope.selectTemplate()
                        f(template);
                    });

                };

                $scope.createTemplate = function () {
                    $mdDialog.show({
                        templateUrl: 'edm/application/directive/templateChooser/template/template-create-popup.html',
                        controller: 'templateCreatePopupController',
                        resolve: {
                            visitCard: function() {
                                return $scope.visitCard;
                            }
                        }
                    })

                };

                $scope.$watch('criteria.searchPhrase', function (newVal) {
                    if(!_.isUndefined(newVal)) {
                        getDataPage();
                    }
                });

                if($scope.showTemplates) {
                    getDataPage();
                }
            }
        };

        return definition;
    }
]);